export default {
  // list
  'container_lading_order.column.orderId': 'orderId',
  'container_lading_order.column.ladingNo': 'ladingNo',
  'container_lading_order.column.supplierId': 'supplier',
  'container_lading_order.column.supplierName': 'supplierName',
  'container_lading_order.column.transportTime': 'transportTime',
  'container_lading_order.column.bookingStatus': 'bookingStatus',
  'container_lading_order.column.cutoffTime': 'cutoffTime',
  'container_lading_order.column.customsClearanceStatus': 'customsClearanceStatus',
  'container_lading_order.column.customsCutoffTime': 'customsCutoffTime',
  'container_lading_order.column.customsRequired': 'customsRequired',
  'container_lading_order.column.createBy': 'createBy',
  'container_lading_order.column.updateBy': 'updateBy',
  'container_lading_order.column.createTime': 'createTime',
  'container_lading_order.column.updateTime': 'updateTime',
  'container_lading_order.column.dataSource': 'dataSource',
  'container_lading_order.column.remark': 'remark',
  'container_lading_order.column.status': 'status',
  // edit
  'container_lading_order.edit.title': 'Edit ContainerLadingOrder',
  'container_lading_order.add.title': 'Add ContainerLadingOrder',
  'container_lading_order.edit.success': 'Edit Successful',
  'container_lading_order.add.success': 'Add Successful',
  'container_lading_order.form.orderId.required': 'orderId cannot be null',
  'container_lading_order.form.supplierId.required': 'supplierId cannot be null',
  'container_lading_order.form.supplierName.required': 'supplierName cannot be null',
  'container_lading_order.form.transportTime.required': 'transportTime cannot be null',
  'container_lading_order.form.customsRequired.required': 'customsRequired cannot be null',
  'container_lading_order.form.orderId': 'orderId',
  'container_lading_order.form.orderId.placeholder': 'Enter orderId',
  'container_lading_order.form.supplierId': 'supplier',
  'container_lading_order.form.supplierId.placeholder': 'Enter supplierId',
  'container_lading_order.form.supplierName': 'supplierName',
  'container_lading_order.form.supplierName.placeholder': 'Enter supplierName',
  'container_lading_order.form.transportTime': 'transportTime',
  'container_lading_order.form.transportTime.placeholder': 'Enter transportTime',
  'container_lading_order.form.bookingStatus': 'bookingStatus',
  'container_lading_order.form.bookingStatus.placeholder': 'Enter bookingStatus',
  'container_lading_order.form.cutoffTime': 'cutoffTime',
  'container_lading_order.form.cutoffTime.placeholder': 'Enter cutoffTime',
  'container_lading_order.form.customsClearanceStatus': 'customsClearanceStatus',
  'container_lading_order.form.customsClearanceStatus.placeholder': 'Enter customsClearanceStatus',
  'container_lading_order.form.customsCutoffTime': 'customsCutoffTime',
  'container_lading_order.form.customsCutoffTime.placeholder': 'Enter customsCutoffTime',
  'container_lading_order.form.customsRequired': 'customsRequired',
  'container_lading_order.form.customsRequired.placeholder': 'Enter customsRequired',
}
